<template>
    <el-card
        style="height: 99%"
        :body-style="{ height: '100%' }"
        class="mead-bike-map"
    >
        <template #header>
            <content-header />
        </template>
        <el-row type="flex" style="height: 100%">
            <div class="amap-page-container">
                <el-amap-search-box
                    class="search-box"
                    :search-option="searchOption"
                    :on-search-result="onSearchResult"
                />
                <el-amap
                    vid="amap"
                    :plugin="plugin"
                    class="amap-demo"
                    :center="center"
                    :default-cursor="defaultCursor"
                    :zoom="zoom"
                    :amap-manager="amapManager"
                    :events="events"
                >
                    <el-amap-marker
                        v-for="(marker, index) in markers"
                        :key="'aa-' + index"
                        :position="marker"
                    />
                    <el-amap-marker
                        :position="marker.position"
                        :events="marker.events"
                        :visible="marker.visible"
                        :draggable="marker.draggable"
                        :icon="marker.icon"
                    />
                    <el-button-group class="info">
                        <el-button
                            type="primary"
                            :disabled="addFenceDisabled"
                            @click="addFence"
                            >绘制骑行区域</el-button
                        >
                        <el-button
                            type="primary"
                            :disabled="addFuSheFenceDisabled"
                            @click="addFusheFence"
                            >绘制辐射区域
                        </el-button>
                        <el-button type="primary" @click="removeFence"
                            >清除围栏</el-button
                        >
                    </el-button-group>
                </el-amap>
            </div>
            <div class="form-class">
                <lz-form
                    ref="form"
                    :submit="onSubmit"
                    :errors.sync="errors"
                    :form.sync="form"
                    :edit-mode="editMode"
                    :rules="rules"
                    label-width="35%"
                    style="width: 100%"
                >
                    <!-- <el-form-item label="请在地图中绘制区域"/> -->

                    <el-form-item label="区域名称" required prop="name">
                        <el-input v-model="form.name" style="width: 80%" />
                    </el-form-item>
                    <el-form-item label="区域状态" required prop="status">
                        <el-switch
                            v-model="form.status"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="正常"
                            inactive-text="禁用"
                        />
                    </el-form-item>
                    <el-form-item
                        label="服务时间"
                        required
                        prop="customer_service_time"
                    >
                        <el-input
                            v-model="form.customer_service_time"
                            style="width: 80%"
                        />
                    </el-form-item>
                    <el-form-item
                        label="服务手机"
                        required
                        prop="customer_service_phone"
                    >
                        <el-input
                            v-model="form.customer_service_phone"
                            style="width: 80%"
                        />
                        <p style="margin: 10px; font-size: 14px; color: green">
                            请在地图中绘制区域
                        </p>
                    </el-form-item>
                    <el-form-item label="复制区域" required prop="clone_id">
                        <el-select
                            v-model="form.clone_id"
                            class="limitwidth"
                            clearable
                            filterable
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="item in areasMain"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                    </el-form-item>
                </lz-form>
                <p
                    style="
                        margin: 10px 22%;
                        font-size: 11px;
                        color: red;
                        width: 70%;
                    "
                >
                    注：红色范围为辐射范围，绿色为骑行范围
                </p>
                <p
                    style="
                        margin: 10px 22%;
                        font-size: 11px;
                        color: red;
                        width: 70%;
                    "
                >
                    注：中心点需要在绘制区域内
                </p>
            </div>
        </el-row>
    </el-card>
</template>

<script>
import VueAMap from "vue-amap";
import LzForm from "@c/LzForm";
import {
    storeArea,
    updateArea,
    getMainAreas,
    getCloneAreasList,
} from "@/api/area";
import FormHelper from "@c/LzForm/FormHelper";

export default {
    name: "Form",
    components: {
        LzForm,
    },
    mixins: [FormHelper],
    data() {
        let self = this;
        let amapManager = new VueAMap.AMapManager();
        var checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("手机号不能为空"));
            } else {
                const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
                if (reg.test(value)) {
                    callback();
                } else {
                    return callback(new Error("请输入正确的手机号"));
                }
            }
        };

        return {
            areasMain: [], //克隆区域列表
            form: {
                name: "",
                area_fence: [],
                area_fushe_fence: [],
                area_centre: "",
                status: true,
                customer_service_time: "",
                customer_service_phone: "",
                clone_id: 0,
            },
            rules: {
                customer_service_phone: [
                    { validator: checkPhone, trigger: "blur" },
                ],
            },
            errors: {},
            center: [121.59996, 31.197646],
            searchOption: {
                city: "郑州",
                citylimit: false,
            },
            defaultCursor: "pointer",
            zoom: 12,
            lng: 0,
            lat: 0,
            loaded: false,
            amapManager: amapManager,
            fenceForm: [],
            markers: [],
            events: {
                init(o) {},
            },
            mouseTool: null,
            mouseToolFushe: null,
            marker: {
                position: [121.5273285, 31.21515044],
                events: {
                    click: () => {
                        // alert('click marker')
                    },
                    dragend: (e) => {
                        this.form.area_centre = {
                            lat: e.lnglat.lat,
                            lng: e.lnglat.lng,
                        };
                        // console.log(this.form.area_centre)
                        // console.log('---event---: dragend')
                        // this.markers[0].position = [e.lnglat.lng, e.lnglat.lat]
                    },
                },
                visible: true,
                draggable: true,
                icon: "http://resource.bike.hanyiyun.com/admin/area_center_20191130170212.png",
            },
            plugin: [
                {
                    pName: "Geolocation",
                    events: {
                        init(o) {
                            // o 是高德地图定位插件实例
                            // console.log(o)
                            o.getCurrentPosition((status, result) => {
                                // 未配置https  定位失败 暂时手动配置
                                self.lng = 113.73350255780726;
                                self.lat = 34.78024666564106;
                                self.center = [self.lng, self.lat];
                                self.marker.position = [self.lng, self.lat];
                                self.form.area_centre = {
                                    lat: self.lat,
                                    lng: self.lng,
                                };
                                self.loaded = true;
                                if (result && result.position) {
                                    self.lng = result.position.lng;
                                    self.lat = result.position.lat;
                                    self.center = [self.lng, self.lat];
                                    self.marker.position = [self.lng, self.lat];
                                    self.form.area_centre = {
                                        lat: self.lat,
                                        lng: self.lng,
                                    };
                                    self.loaded = true;
                                    self.$nextTick();
                                }
                            });
                        },
                    },
                },
                {
                    pName: "Scale",
                    // offset: { x: 20, y: 20 },
                    position: "RB",
                    events: {
                        init(instance) {
                            // console.log(instance)
                        },
                    },
                },
                {
                    pName: "ToolBar",
                    events: {
                        init(instance) {
                            // console.log(instance)
                        },
                    },
                },
            ],
            addFenceDisabled: false,
            addFuSheFenceDisabled: false,
        };
    },
    created() {
        this.getCloneAreas();
    },
    methods: {
        async getCloneAreas() {
            const { data } = await getCloneAreasList();
            this.areasMain = data;
        },
        onSearchResult(pois) {
            let latSum = 0;
            let lngSum = 0;
            if (pois.length > 0) {
                pois.forEach((poi) => {
                    let { lng, lat } = poi;
                    lngSum += lng;
                    latSum += lat;
                    this.markers.push([poi.lng, poi.lat]);
                });
                let center = {
                    lng: lngSum / pois.length,
                    lat: latSum / pois.length,
                };
                this.center = [center.lng, center.lat];
            }
        },
        async onSubmit() {
            // this.form.area_centre = { lat: this.marker.position[1], lng: this.marker.position[0] }
            // console.log(this.form)
            if (this.editMode) {
                await updateArea(this.resourceId, this.form);
            } else {
                await storeArea(this.form);
            }
        },
        addFence() {
            let _this = this;
            _this.defaultCursor = "crosshair";
            let map = this.amapManager.getMap();
            map.plugin(["AMap.MouseTool", "AMap.Geocoder"], function () {
                // eslint-disable-next-line no-undef
                let mouseTool = new AMap.MouseTool(map);
                _this.mouseTool = mouseTool;
                // eslint-disable-next-line no-unused-vars
                var drawPolygon = mouseTool.polygon({ strokeColor: "#00f000" });

                // 添加事件
                // eslint-disable-next-line no-undef
                AMap.event.addListener(mouseTool, "draw", function (e) {
                    e.obj.getPath().forEach((item) => {
                        console.log(item);
                        var im = { lat: item.lat, lng: item.lng };
                        _this.form.area_fence.push(im);
                    });
                    _this.defaultCursor = "pointer";
                    _this.mouseTool.close();
                });
            });
            this.addFenceDisabled = true;
        },
        addFusheFence() {
            let _this = this;
            _this.defaultCursor = "crosshair";
            let map = this.amapManager.getMap();
            map.plugin(["AMap.MouseTool", "AMap.Geocoder"], function () {
                // eslint-disable-next-line no-undef
                let mouseTool = new AMap.MouseTool(map);
                _this.mouseToolFushe = mouseTool;
                // eslint-disable-next-line no-unused-vars
                var drawPolygon = mouseTool.polygon({ strokeColor: "#f00000" });

                // 添加事件
                // eslint-disable-next-line no-undef
                AMap.event.addListener(mouseTool, "draw", function (e) {
                    e.obj.getPath().forEach((item) => {
                        var im = { lat: item.lat, lng: item.lng };
                        _this.form.area_fushe_fence.push(im);
                    });
                    _this.defaultCursor = "pointer";
                    _this.mouseToolFushe.close();
                });
            });
            this.addFuSheFenceDisabled = true;
        },
        removeFence() {
            this.form.area_fence = [];
            this.form.area_fushe_fence = [];
            if (this.mouseTool) {
                this.mouseTool.close(true);
            }
            if (this.mouseToolFushe) {
                this.mouseToolFushe.close(true);
            }
            this.addFenceDisabled = false;
            this.addFuSheFenceDisabled = false;
        },
    },
};
</script>
<style lang="scss" scoped>
.amap-page-container {
    width: 75%;
    position: relative;
    // height: 100%;
    top: -30px;
}

.amap-demo {
    /*height: 88%;*/
}

.info {
    border-radius: 0.25rem;
    position: absolute;
    top: 70px;
    width: auto;
    border-width: 0;
    right: 20px;
}

.search-box {
    height: 36px;
    border-radius: 0.25rem;
    top: 65px;
    border-width: 1px;
    left: 90px;
}

.form-class {
    width: 25%;
    overflow: auto;
}
</style>
